import {
  AfterContentChecked,
  Component,
  DestroyRef,
  OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { PreviewService } from '@core/services/preview.service';
import { ThemeService } from '@core/services/theme.service';
import { GdprPageComponent } from '@feature/gdpr-page-management/component/gdpr-page/gdpr-page.component';
import { InformationPageComponent } from '@feature/information-page-mangement/components/information-page/information-page.component';
import { LanguagePageComponent } from '@feature/language-management/componenets/language-page/language-page.component';
import { PasswordPageComponent } from '@feature/password-management/components/password-page/password-page.component';
import { SurveyPageComponent } from '@feature/survey-management/components/survey-page/survey-page.component';
import { AnswerModuleResponse } from '@shared/models/answer-module-response';
import { View } from '@shared/models/view';
import { PreviewMode, toPreviewMode } from "@shared/models/enums/preview-mode.enum";
import { updateTextDirection } from '@shared/utils/helper.util';

@Component({
  selector: 'app-preview-content',
  imports: [
    SurveyPageComponent,
    InformationPageComponent,
    LanguagePageComponent,
    GdprPageComponent,
    PasswordPageComponent,
  ],
  templateUrl: './preview-content.component.html',
  styleUrl: './preview-content.component.scss',
})
export class PreviewContentComponent implements AfterContentChecked, OnInit {
  response?: AnswerModuleResponse;
  previewMode = PreviewMode.FreeFlow;
  view?: View;
  questionId?: string;
  themeId?: string;
  sessionId?: string;
  questId: string | null = '';

  constructor(
    private route: ActivatedRoute,
    private previewService: PreviewService,
    private themeService: ThemeService,
    private destroyRef: DestroyRef,
  ) {}

  ngAfterContentChecked(): void {
    this.goToQuestion();
  }

  ngOnInit() {
    this.getPreview();
  }

  getPreview() {
    this.route.paramMap
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(async (params) => {
        this.questId = params.get('questId');
      });

    this.route.queryParamMap
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((queryParams) => {
        const previewParams = {
          mode: toPreviewMode(queryParams.get('mode'), this.previewMode),
          language: queryParams.get('language') || '',
          showConditions: queryParams.get('showConditions') || 'true',
          questionId: queryParams.get('questionId') || undefined,
          themeId: queryParams.get('themeId') || undefined,
          sessionId: queryParams.get('sessionId') || undefined,
          pageName: queryParams.get('pageName') || undefined,
        };

        this.previewMode = previewParams.mode;
        this.questionId = previewParams.questionId;
        this.themeId = previewParams.themeId;
        if (this.questId && previewParams.language) {
          this.previewService
            .getPreview(
              this.questId,
              previewParams.language,
              previewParams.mode,
              previewParams.showConditions,
              previewParams.questionId,
              previewParams.themeId,
              previewParams.sessionId,
              previewParams.pageName,
            )
            .subscribe((response) => {
              this.response = response;
              this.view = response.view;
              this.themeService.loadTheme(response.themeId);
              updateTextDirection(response.language);
            });
        }
      });
  }

  goToQuestion() {
    if (this.questionId) {
      const element = document.getElementById(this.questionId);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center',
        });
        this.questionId = undefined;
      }
    }
  }

  handleResponseChange(response: AnswerModuleResponse) {
    this.response = response;
    this.view = response.view;
  }
}
